import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
/** Divider (README.md > Atoms): 1px border, nothing more. */
export function Divider({ orientation = 'horizontal', className, ...props }) {
    return (_jsx("hr", { role: "separator", "aria-orientation": orientation, className: cn('border-border', orientation === 'horizontal' ? 'w-full border-t' : 'h-full border-l', className), ...props }));
}
//# sourceMappingURL=Divider.js.map